import { Check, X } from "lucide-react";

import { Switch } from "@/components/ui/switch";
import { CustomEmailDomainsTableActions } from "./CustomEmailDomainsTableActions";

export const getCustomEmailDomainsTableColumns = ({ handleSetAsDefault }) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 50,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Domain Name",
      id: "Domain Name",
      accessorKey: "name",
    },
    {
      header: "Verified",
      id: "Verified",
      accessorKey: "verified",
      size: 100,
      cell: ({ row }) => {
        const value = row.original.verified;
        return (
          <div>
            {value === true && (
              <Check
                className="tw:size-4 tw:text-success"
                aria-label="Verified"
              />
            )}
            {value === false && (
              <X
                className="tw:size-4 tw:text-muted-foreground"
                aria-label="Not verified"
              />
            )}
          </div>
        );
      },
    },
    {
      header: "Set as Default",
      id: "Set as Default",
      accessorKey: "is_default",
      size: 100,
      enableSorting: false,
      cell: ({ row }) => (
        <Switch
          name={`is_default_${row.original.id}`}
          checked={row.original.is_default}
          onCheckedChange={checked =>
            handleSetAsDefault(row.original.id, checked)
          }
          aria-label="Set as default"
        />
      ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CustomEmailDomainsTableActions original={row.original} />
      ),
    },
  ];
};
